export const apiUrls = {
  //Auth
  login: "admin/v1/login",
  //Dashborad
  dashboard: "admin/v1/dashboard",
  getAllParentcategory:"admin/v1/getAllParentcategory",
  singleImage:"upload/singleImage",
  multiImage:"upload/multiImage",
  //Language
  addLanguage:"admin/v1/addLanguage",
  updateLanguage:"admin/v1/updateLanguage",
  getLanguage:"admin/v1/getLanguage",
  deleteLanguage:"admin/v1/deleteLanguage",
  statusLanguage:"admin/v1/statusLanguage",
  //Users
  addUser:"admin/v1/addUser",
  updateUser:"admin/v1/updateUser",
  deleteUser:"admin/v1/deleteUser",
  statusUser:"admin/v1/statusUser",
  getUser:"admin/v1/getUser",
  getContacts:"admin/v1/getContacts",
  deleteContacts:"admin/v1/deleteContacts",
//getParentcategory
  getParentcategory:"admin/v1/getParentcategory",
  addParentcategory:"admin/v1/addParentcategory",
  updateParentcategory:"admin/v1/updateParentcategory",
  deleteParentcategory:"admin/v1/deleteParentcategory",
  statusParentcategory:"admin/v1/statusParentcategory",
  //getSubcategory
  getSubcategory:"admin/v1/getSubcategory",
  addSubcategory:"admin/v1/addSubcategory",
  updateSubcategory:"admin/v1/updateSubcategory",
  statusSubcategory:"admin/v1/statusSubcategory",
  deleteSubcategory:"admin/v1/deleteSubcategory",
  getchildCategoryImage:"admin/v1/getchildCategoryImage",
  deleteImage:"admin/v1/deleteImage",
  addchildCategoryImage:"admin/v1/addchildCategoryImage",
  updatechildCategoryImage:"admin/v1/updatechildCategoryImage",
  getChildCategory:"admin/v1/getChildCategory",
  addChildCategory:"admin/v1/addChildCategory",
  addChildSubCategory:"admin/v1/addChildSubCategory",
  updateChildSubCategory:"admin/v1/updateChildSubCategory",
  getChildSubCategory:"admin/v1/getChildSubCategory",
  updateChildCategory:"admin/v1/updateChildCategory",
  getCategoryDetail:"admin/v1/getCategoryDetail",
  getchildCategoryLanguageImage:"admin/v1/getchildCategoryLanguageImage",
//Prayer
  getAllPrayer:"admin/v1/getAllPrayer",
  addPrayer:"admin/v1/addPrayer",
  statusPrayer:"admin/v1/statusPrayer",
  updatePrayer:"admin/v1/updatePrayer",
  deletePrayer:"admin/v1/deletePrayer",

  getprayerassistant:"admin/v1/get-prayer-assistant",
  createprayerassistant:"admin/v1/create-prayer-assistant",
  updateprayerassistant:"admin/v1/update-prayer-assistant",
  statusprayerassistant:"admin/v1/status-prayer-assistant",
  deleteprayerassistant:"admin/v1/delete-prayer-assistant",
  getbyidprayerassistant:"admin/v1/get-by-id-prayer-assistant",
  createbyidprayerassistant:"admin/v1/create-prayer-assistant",
  updatebyidprayerassistant:"admin/v1/update-prayer-assistant",
  statusbyidprayerassistant:"admin/v1/status-prayer-assistant",
  deletebyidprayerassistant:"admin/v1/delete-prayer-assistant",
  //Media
  getAllMedia:"admin/v1/getAllMedia",
  deleteMedia:"admin/v1/delete-media-prayer",
  statusMedia:"admin/v1/status-media-prayer",
  addMedia:"admin/v1/create-media-prayer",
  updateMedia:"admin/v1/update-media-prayer",
  listmediacategory:"admin/v1/list-media-category",
  statusmediacategory:"admin/v1/status-media-category",
createmediacategory:"admin/v1/create-media-category",
updatemediacategory:"admin/v1/update-media-category",
deletemediacategory:"admin/v1/delete-media-category",
getallmediaprayer:"admin/v1/getall-media-prayer",
getBiblePrayer:"admin/v1/getBiblePrayer",
addBiblePrayer:"admin/v1/addBiblePrayer",
updateBiblePrayer:"admin/v1/updateBiblePrayer",
statusBiblePrayer:"admin/v1/statusBiblePrayer",
deleteBiblePrayer:"admin/v1/deleteBiblePrayer",
getBiblePrayerDetail:"admin/v1/getBiblePrayerDetail",
  //keyword
  addPrayerKeyword:"admin/v1/addPrayerKeyword",
  getPrayerKeyword:"admin/v1/getPrayerKeyword",
  updatePrayerKeyword:"admin/v1/updatePrayerKeyword",
  deletePrayerKeyword:"admin/v1/deletePrayerKeyword",
deleteChildCategory:"admin/v1/deleteChildCategory",
//Report
getReportPrayer:"admin/v1/getReportPrayer",
getContactMsg:"admin/v1/getContactMsg",
  //users
  userlogin:"web/v1/login",
  addContact:"web/v1/addContact",
  userragister:"web/v1/register",
  createcheckoutsession:"web/v1/create-checkout-session",
  userDetail:"web/v1/userDetail",
  profile:"web/v1/profile",
  subscriptioncance:"web/v1/subscriptioncancel"
};
